import gql from "graphql-tag";

export const GET_EVENT_BY_ID = gql`
  query events_by_pk(
    $id: uuid!
    $userId: uuid!
    $current_date_time: timestamp
  ) {
    events_by_pk(id: $id) {
      id
      type
      name
      date_time
      description
      external_ticket_url
      event_payment_type
      total_attendees
      council_url
      is_ticket_required
      event_paid_ticket_details {
        id
        option_name
        description
        price
        quantity_available
        used_ticket_count: event_attendees_aggregate(
          where: { quantity: { _gt: 0 } }
        ) {
          aggregate {
            sum {
              quantity
            }
          }
        }
        event {
          event_payment_type
        }
      }
      event_image_galleries {
        id
        image_url
        image_path
      }
      event_payment_type
      total_attendees
      categories
      community_id
      start_date_time
      end_date_time
      is_all_day
      cover_photo
      cover_photo_path
      is_ticket_required
      business_profile {
        id
        name
        business_profile_path
        business_profile_photo
        categories
        is_business_added_to_favorites: favorites_aggregate(
          where: { user_id: { _eq: $userId } }
        ) {
          aggregate {
            count
          }
        }
      }
      users_view {
        full_name
        id
        profile_photo_path
        profile_photo
      }
      council_profile {
        id
        name
        council_profile_path
        council_profile_photo
      }
      location: event_view {
        location_text
        latitude_double
        longitude_double
      }
      event_likes_aggregate(where: { event_id: { _eq: $id } }) {
        aggregate {
          count
        }
      }
      is_event_liked_by_user: event_likes_aggregate(
        where: { user_id: { _eq: $userId } }
      ) {
        aggregate {
          count
        }
      }
      event_attendees(
        order_by: { created_at: desc }
        where: { is_going: { _eq: true } }
      ) {
        id
        quantity
        users_view {
          full_name
          name
          lastname
          profile_photo
          profile_photo_path
        }
      }
      total_event_attendees: event_attendees_aggregate(
        where: { is_going: { _eq: true } }
      ) {
        aggregate {
          count
        }
      }
      current_user_going_to_attend: event_attendees_aggregate(
        where: { is_going: { _eq: true }, user_id: { _eq: $userId } }
      ) {
        aggregate {
          count
        }
      }
      is_event_added_to_favorites: favorites_aggregate(
        where: { event_id: { _eq: $id }, user_id: { _eq: $userId } }
      ) {
        aggregate {
          count
        }
      }
    }
    event_passed: events_aggregate(
      where: {
        _and: [
          { id: { _eq: $id } }
          { end_date_time: { _lt: $current_date_time } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
